import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

import { PermissionHierarchy } from '../Modules/management/models/organization/security-role-permission.model';
import { LicenseWiseSecurityRoles } from '../Modules/management/enums/licese-wise-user-roles.enum';
import { OrganizationUserModel } from '../Modules/management/models/organization/organization-user.model';
import { Organization, OrgnaizationForDashboard } from '../Modules/management/models/organization/organization.model';
import { UntypedFormGroup } from '@angular/forms/types/forms';

@Injectable({
    providedIn: 'root',
})
export class OrganizationDataService {
    organizationData: Organization;
    allOrganizations: OrgnaizationForDashboard[];
    isOrganzationEdit: boolean = false;
    currentOrg: string;
    currentOrgId: string;
    currentInstance: string;
    organizationNames;
    formData = new FormData();
    userLicenseType = [];
    userRoles = [];
    organizationID = new Subject<string>();
    userRolesResponse: any;
    userSecurityRoles: any = [];
    isFedOrg: boolean = false;
    numberOfUsers = new Subject<number>();
    currentOrganizationName = new BehaviorSubject<string>(null);

    //validators for organization-wizard
    isDisableOrgTab$ = new Subject<boolean>();
    isDisableUserTypeWizard = new Subject<boolean>();
    isDisableUsersWizard = new Subject<boolean>();
    isDisableInstanceWizard = new Subject<boolean>();
    isDisableAzureDetailWizard = new Subject<boolean>();
    isFederatedOrganization$ = new BehaviorSubject<boolean>(false);
    isDisableBackButton$ = new Subject<boolean>();
    instanceLimit: Subject<number> = new Subject<number>();
    // navigateThroughWizard = new Subject<number>();

    navigateThroughWizard = new Subject<number>();

    organizationTabNext = new Subject<string>();
    organizationTabNextCreate = new Subject<string>();
    OrganizationTabBack = new Subject<string>();
    activeOrganizationTab = new Subject<string>();
    updateisSecurityRoleSaved = new Subject<boolean>();
    addOrganizationFrom: UntypedFormGroup;
    constructor() {
        this.isFederatedOrganization$.subscribe((orgType) => {
            this.isFedOrg = orgType;
        });
    }

    setOrganizationData(addedOrganization: Organization) {
        this.organizationData = addedOrganization;
    }

    getCurrentFormData() {
        return this.formData;
    }

    getUserLicenseType() {
        return this.userLicenseType;
    }

    setUserLicenseType(licenseType: any[]) {
        this.userLicenseType = licenseType;
    }

    getAddedOrgainzationData() {
        return this.organizationData;
    }

    setUserRoles(userRoles: any, userRolesObject: any) {
        this.userRoles = userRoles;
        this.userRolesResponse = userRolesObject;
    }

    getUserSecurityRoles(): PermissionHierarchy[] {
        return this.userSecurityRoles;
    }

    setUserSecurityRoles(securityRoles: any) {
        this.userSecurityRoles = securityRoles;
    }

    setFormDataValuesForOrganization(organizationData: FormData) {
        this.formData = new FormData();
        this.formData = organizationData;
    }

    // * navigation handler for organization
    orgNavigationHandler(index: number) {
        switch (index) {
            case 0: // * non-fed org - Org Details tab (NEXT BUTTON)
                this.navigateThroughWizard.next(1);
                this.isDisableOrgTab$.next(true);
                this.isDisableUserTypeWizard.next(false); // * enable the user-typ tab
                this.isDisableUsersWizard.next(true);
                this.isDisableInstanceWizard.next(true);
                break;

            case 1: // * fed org - Org Details tab (NEXT BUTTON)
                this.navigateThroughWizard.next(1);
                this.isDisableOrgTab$.next(true);
                this.isDisableAzureDetailWizard.next(false); // * enable the azure-ad tab
                this.isDisableUserTypeWizard.next(true);
                this.isDisableUsersWizard.next(true);
                this.isDisableInstanceWizard.next(true);
                break;

            case 2: // * Azure Details tab (NEXT BUTTON)
                this.navigateThroughWizard.next(2);
                this.isDisableOrgTab$.next(true);
                this.isDisableAzureDetailWizard.next(true);
                this.isDisableUserTypeWizard.next(false); // * enable the user-typ tab
                this.isDisableUsersWizard.next(true);
                this.isDisableInstanceWizard.next(true);
                break;

            case 3: // * User types tab (NEXT BUTTON)
                if (this.isFedOrg) {
                    this.navigateThroughWizard.next(3);
                } else {
                    this.navigateThroughWizard.next(2);
                }
                this.isDisableOrgTab$.next(true);
                this.isDisableAzureDetailWizard.next(true);
                this.isDisableUserTypeWizard.next(true);
                this.isDisableUsersWizard.next(false); // * enable the users tab
                this.isDisableInstanceWizard.next(true);
                break;

            case 4: // * users list tab (NEXT BUTTON)
                if (this.isFedOrg) {
                    this.navigateThroughWizard.next(4);
                } else {
                    this.navigateThroughWizard.next(3);
                }
                this.isDisableOrgTab$.next(true);
                this.isDisableAzureDetailWizard.next(true);
                this.isDisableUserTypeWizard.next(true);
                this.isDisableUsersWizard.next(true);
                this.isDisableInstanceWizard.next(false); // * enable the instance tab
                break;

            case 5: // * instance tab (BACK BUTTON)
                if (this.isFedOrg) {
                    this.navigateThroughWizard.next(3);
                } else {
                    this.navigateThroughWizard.next(2);
                }
                break;

            // case 5: // * users list tab (BACK BUTTON)
            //     if (this.isFedOrg) {
            //         this.navigateThroughWizard.next(2);
            //     } else {
            //         this.navigateThroughWizard.next(1);
            //     }
            //     break;

            case 6: // * user-types (BACK BUTTON)
                if (this.isFedOrg) {
                    this.navigateThroughWizard.next(1);
                } else {
                    this.navigateThroughWizard.next(0);
                }
                break;

            case 7: // * Azure details tab (BACK BUTTON)
                this.navigateThroughWizard.next(0);
                break;
        }
    }

    // * helper method to filter the security Roles
    filterSecurityRolesByLicense(securityRoleList: PermissionHierarchy[], organization: Organization): PermissionHierarchy[] {
        if (!securityRoleList) {
            return [];
        }
        let scenario = this.checkOrganizationLicense(organization);
        let result: PermissionHierarchy[] = [];

        switch (scenario) {
            case LicenseWiseSecurityRoles.onlyInformate:
                result = this.filterRolesByName(securityRoleList, ['informate', 'super admin'], true);
                break;
            case LicenseWiseSecurityRoles.onlyIdms:
                result = this.filterRolesByName(securityRoleList, ['idms', 'super admin'], true);
                break;
            case LicenseWiseSecurityRoles.idmsInformate:
                result = securityRoleList.slice();
                break;
        }

        return result;
    }

    // * helper for edit user modal
    getFilterSecurityRoleForUser(availableSecurityRoles: PermissionHierarchy[], user: OrganizationUserModel) {
        let zeroIndex = 0;
        let securityRole = this.getUserSecurityRoles().find((item) => item.securityRoleId === user.securityRoles[zeroIndex].securityRole.securityRoleId);
        return [...availableSecurityRoles, securityRole];
    }

    // * helper function for filter
    filterRolesByName(securityRoleList: PermissionHierarchy[], names: string[], isDerivedFromTemplate: boolean): PermissionHierarchy[] {
        return securityRoleList.filter(
            (role) => (names.some((name) => role.name.toLowerCase().includes(name)) && role.isDerivedFromTemplate) || !role.isDerivedFromTemplate
        );
    }

    // * helper method for deciding cases
    checkOrganizationLicense(organization: Organization): number {
        if (!organization) {
            return -1; // Return a default value to indicate an invalid organization
        }

        if (organization.licenseLimitICE > 0 && organization.licenseLimitiDMS == 0) {
            return LicenseWiseSecurityRoles.onlyInformate;
        } else if (organization.licenseLimitiDMS > 0 && organization.licenseLimitICE == 0) {
            return LicenseWiseSecurityRoles.onlyIdms;
        } else {
            return LicenseWiseSecurityRoles.idmsInformate;
        }
    }
}
